import { useActiveJob } from '../../hooks/active-job.hook';
import { JobPublishTitle } from '../titles/JobPublishTitle';

export const JobPublishPageNav = (): React.ReactElement<any, any> | null => {
    const { job } = useActiveJob();

    return <JobPublishTitle job={job} />;
};
